// general
const modalOverlay = document.getElementById('modal-overlay')
// create
const openModalBtn = document.getElementById('open-modal')
const closeModalBtn = document.getElementById('close-modal')
// delete

if (openModalBtn) {
  openModalBtn.addEventListener('click', function(e) {
    modalOverlay.style.display = 'flex'
  })

  openModalBtn.addEventListener('click', function(e) {
    modalOverlay.style.display = 'flex'
  })
}

if (closeModalBtn) {
  closeModalBtn.addEventListener('click', function(e) {
    modalOverlay.style.display = 'none'
  })
}
